import React from 'react';
import { motion } from 'framer-motion';

const TestPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Component Testing Page</h1>
        
        {/* Typography Section */}
        <section className="mb-12 bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">Typography Tests</h2>
          
          {/* TwCenMTCondensedExtraBold Tests */}
          <div className="mb-8">
            <h3 className="text-xl font-semibold mb-4">TwCenMTCondensedExtraBold</h3>
            <div className="space-y-4">
              <h1 className="text-4xl subheading-font">H1 Heading - TwCenMTCondensedExtraBold</h1>
              <h2 className="text-3xl subheading-font">H2 Heading - TwCenMTCondensedExtraBold</h2>
              <p className="text-xl subheading-font">Paragraph text in TwCenMTCondensedExtraBold</p>
            </div>
          </div>

          {/* Geogrotesque Tests */}
          <div className="mb-8">
            <h3 className="text-xl font-semibold mb-4">Geogrotesque</h3>
            <div className="space-y-4">
              <h1 className="text-4xl geogrotesque-heading">H1 Heading - Geogrotesque</h1>
              <h2 className="text-3xl geogrotesque-heading">H2 Heading - Geogrotesque</h2>
              <p className="text-xl geogrotesque-heading">Paragraph text in Geogrotesque</p>
            </div>
          </div>
        </section>

        {/* Button Section */}
        <section className="mb-12 bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">Button Tests</h2>
          <div className="space-y-4">
            <button className="bg-[#D3242A] text-white px-6 py-2 rounded-full hover:bg-red-700 transition-colors">
              Primary Button
            </button>
            <button className="bg-white text-[#D3242A] border-2 border-[#D3242A] px-6 py-2 rounded-full hover:bg-red-50 transition-colors">
              Secondary Button
            </button>
          </div>
        </section>

        {/* Animation Section */}
        <section className="mb-12 bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">Animation Tests</h2>
          <div className="space-y-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="bg-[#D3242A] text-white p-4 rounded-lg"
            >
              Fade In Animation
            </motion.div>
            
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-white border-2 border-[#D3242A] text-[#D3242A] p-4 rounded-lg cursor-pointer"
            >
              Hover & Tap Animation
            </motion.div>
          </div>
        </section>

        {/* Color Section */}
        <section className="mb-12 bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">Color Tests</h2>
          <div className="grid grid-cols-2 gap-4">
            <div className="p-4 bg-[#D3242A] text-white rounded-lg">
              Primary Red (#D3242A)
            </div>
            <div className="p-4 bg-white border-2 border-[#D3242A] text-[#D3242A] rounded-lg">
              White with Red Border
            </div>
          </div>
        </section>

        {/* Responsive Design Section */}
        <section className="mb-12 bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">Responsive Design Tests</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div className="bg-gray-200 p-4 rounded-lg">
              <p className="text-sm md:text-base lg:text-lg">Responsive Text</p>
            </div>
            <div className="bg-gray-200 p-4 rounded-lg">
              <p className="text-sm md:text-base lg:text-lg">Responsive Text</p>
            </div>
            <div className="bg-gray-200 p-4 rounded-lg">
              <p className="text-sm md:text-base lg:text-lg">Responsive Text</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default TestPage; 